@if (isDeleting) {
  <mat-dialog-content>
    {{ "publist.more.delete.waiting" | translate }}
  </mat-dialog-content>
} @else {
  <mat-dialog-content>
    {{ "publist.more.delete.confirmation" | translate: { pub: data.pub.verbatimText } }}
  </mat-dialog-content>
  <mat-dialog-actions class="bottom-buttons">
    <button mat-raised-button mat-dialog-close>{{ "cancel" | translate }}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{ "continue" | translate }}</button>
  </mat-dialog-actions>
}
